import { Injectable } from '@angular/core';
import { getDatabase, ref, set, get, child, onValue, Database } from 'firebase/database';
import { SiteContent, TeamMember } from '../schema';
import { env } from 'src/environments/environment';
import { initializeApp } from 'firebase/app';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private db!: Database;

  constructor() {
    const app = initializeApp(env.firebase);
    this.db = getDatabase(app);
  }

  getContent(key: string) {
    const contentRef = ref(this.db, `siteContent/${key}`);
    return new Promise<string>((resolve, reject) => {
      onValue(contentRef, (snapshot) => {
        if (snapshot.exists()) {
          resolve(snapshot.val());
        } else {
          resolve('');
        }
      }, (error) => reject(error));
    });
  }

  updateContent(key: string, newText: string) {
    const contentRef = ref(this.db, `siteContent/${key}`);
    return set(contentRef, newText);
  }

  getPageContent(page: string) {
    const pageRef = ref(this.db, `siteContent/${page}`);
    return new Promise<any>((resolve, reject) => {
      onValue(pageRef, (snapshot) => {
        if (snapshot.exists()) {
          resolve(snapshot.val());
        } else {
          resolve({});
        }
      }, (error) => reject(error));
    });
  }
}
